import { https } from 'core/services/https';
import { TBannerResponseDTO, TLoyaltyUrlRequestDTO, TShortcutsResponseDTO } from './customization.dto';

export const baseUrl = '/v1';

export const customizationData = {
  getBanners: async (customerId: number) => {
    const data = await https.get<Array<TBannerResponseDTO>>(`${baseUrl}/banners`, {
      headers: { 'Gtm-Customer-Id': customerId },
    });

    return data;
  },

  getLoyaltyUrl: async (request: TLoyaltyUrlRequestDTO) => {
    const data = await https.get<{ url: string }>(`${baseUrl}/banners/${request.bannerId}/loyalty-url`, {
      headers: { 'Gtm-Customer-Id': request.customerId },
    });

    return data?.url ?? '';
  },

  getShortcuts: async (customerId: number) => {
    const data = await https.get<TShortcutsResponseDTO>(`${baseUrl}/shortcuts`, {
      headers: { 'Gtm-Customer-Id': customerId },
    });

    return data?.items;
  },
};
